import React from 'react';

const ExamQuestionImage = ({ imageUrl }: IProps) => (
    <div className="d-flex mt-2 mb-2">
        <img style={{ maxWidth: '100%' }} src={imageUrl} alt="question_image" />
    </div>
);

interface IProps {
    imageUrl: string;
}

export default ExamQuestionImage;
